import { NotAuthorized, NotFound, PasswordChanged } from "@modernary/mui/components/common";
import type { RouterOptions } from "vue-router";
import NotImplemented from "./components/NotImplemented.vue";
import FacilityRoutes, { FacilityRouteNames } from "./views/facility/facilityRoutes";
import Home from "./views/Home.vue";
import IncidentRoutes, { IncidentRouteNames } from "./views/incident/incidentRoutes";
import InquiryRoutes, { InquiryRouteNames } from "./views/inquiry/inquiryRoutes";
import OrganizationRoutes, { OrganizationRouteNames } from "./views/organization/organizationRoutes.jsx";
import SiteRoutes, { SiteRouteNames } from "./views/site/siteRoutes";

// Troubleshoot your routes using this - https://paths.esm.dev

export const routeNames = {
  home: "Home",
  passwordChanged: "PasswordChanged",
  notAuthorized: "NotAuthorized",
  notImplemented: "NotImplemented",
  sites: {
    ...SiteRouteNames,
  },
  facilities: {
    ...FacilityRouteNames,
  },
  incidents: {
    ...IncidentRouteNames,
  },
  inquiries: {
    ...InquiryRouteNames,
  },
  organizations: {
    ...OrganizationRouteNames,
  },
};

export const routes: RouterOptions["routes"] = [
  { path: "/", component: Home, name: routeNames.home, meta: { title: "Home" } },
  {
    path: "/password-changed",
    component: PasswordChanged,
    name: routeNames.passwordChanged,
    meta: { title: "Password Changed" },
  },
  {
    path: "/unauthorized",
    component: NotAuthorized,
    name: routeNames.notAuthorized,
    meta: { title: "Not Authorized" },
  },
  {
    path: "/not-implemented",
    component: NotImplemented,
    name: routeNames.notImplemented,
    meta: { title: "Not Implemented" },
  },
  ...SiteRoutes,
  ...FacilityRoutes,
  ...IncidentRoutes,
  ...InquiryRoutes,
  ...OrganizationRoutes,
  { path: "/:path(.*)", component: NotFound },
];
